import { useAuth } from './hooks/useAuth'
import { useAuthStore } from './store/authStore'
import { useTheme } from './hooks/useTheme'
import { LoadingSpinner } from './components/LoadingSpinner'
import { AppRoutes } from './routes/AppRoutes'

function App() {
  const { isAuthenticated, isLoading } = useAuth()
  const { user } = useAuthStore()

  useTheme()

  const homePage = user?.pagina_inicio || '/dashboard'

  if (isLoading) {
    return <LoadingSpinner message="Verificando autenticación..." />
  }

  return <AppRoutes isAuthenticated={isAuthenticated} homePage={homePage} />
}

export default App
